module.exports = __webpack_public_path__ + "static/img/home_remark_03.2f953d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_remark_03.png
// module id = qr7Q
// module chunks = 1